'use client'

import Link from 'next/link'
import { IconEye, IconClock } from '@tabler/icons-react'

interface Collection {
  id: string
  title: string | null
  description: string | null
  packages_key: string
  packages: string[]
  unique_visitors: number
  total_views: number
  created_at: string
  is_featured: boolean
  category: string | null
  tags: string[] | null
}

interface CollectionGridProps {
  collections: Collection[]
}

export default function CollectionGrid({ collections }: CollectionGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {collections.map((collection) => (
        <Link
          key={collection.id}
          href={`/compare/${collection.packages_key}`}
          className="block p-6 bg-white rounded-lg border border-gray-200 hover:border-[#0066CC] transition-colors"
        >
          <h2 className="text-lg font-medium mb-2">{collection.title}</h2>
          <p className="text-gray-600 text-sm mb-4">{collection.description}</p>
          
          <div className="flex items-center gap-4 text-sm text-gray-500">
            <div className="flex items-center gap-1">
              <IconEye size={16} />
              <span>{collection.unique_visitors} visitors</span>
            </div>
            <div className="flex items-center gap-1">
              <IconClock size={16} />
              <span>{new Date(collection.created_at).toLocaleDateString()}</span>
            </div>
          </div>
          
          {collection.category && (
            <div className="mt-3">
              <span className="inline-block px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded">
                {collection.category}
              </span>
            </div>
          )}
          
          {collection.tags && collection.tags.length > 0 && (
            <div className="mt-2 flex flex-wrap gap-2">
              {collection.tags.map(tag => (
                <span 
                  key={tag}
                  className="inline-block px-2 py-1 text-xs bg-blue-50 text-blue-600 rounded"
                >
                  {tag}
                </span>
              ))}
            </div>
          )}
        </Link>
      ))}
    </div>
  )
} 